<template>
  <fragment>
    <div id="nav">
      <template v-if="isLocal">
        <router-link :to="{ name: 'Home' }">Home</router-link>
        |
        <router-link :to="{ name: 'Main' }">Main</router-link>
        |
        <router-link :to="{ name: 'Page' }">Page</router-link>
        |
        <router-link :to="{ name: 'Order' }">Order</router-link>
        |
        <router-link :to="{ name: 'Print' }">Print</router-link>
        |
        <router-link :to="{ name: 'Offer' }">Offer</router-link>
        |
      </template>
      <template v-if="isAdmin">
        <router-link :to="{ name: 'Users' }">Users</router-link>
        |
        <router-link :to="{ name: 'Goods' }">Goods</router-link>
        |
      </template>
      <!--      |-->
      <button type="button" @click="logout">logout</button>
      <!--      isLogin: {{ isLogin }} | email : {{ email }} | uid : {{ uid }}-->
    </div>
    <router-view />
  </fragment>
</template>

<script>
import firebase from "firebase/app";
import messages from "@/utils/message";
import { Fragment } from "vue-fragment";

export default {
  name: "App",
  components: { Fragment },
  data() {
    return {
      isLocal: !!process.env.VUE_APP_LOGIN ?? false,
      email: "",
      isLogin: false,
      uid: ""
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters["manager"]?.role === "admin";
    }
  },
  methods: {
    async logout() {
      await this.$store.dispatch("logout");
      this.$router.push("/");
      this.$message(messages["logout"]);
    }
  },
  created() {
    firebase.auth().onAuthStateChanged(async user => {
      this.isLogin = !!user;
      this.email = await this.$store.dispatch("getEmail");
      this.uid = await this.$store.dispatch("getUID");
      this.$store.getters.manager.email = this.email;
    });

    this.$store.dispatch("fetchOptions");
    this.$store.dispatch("fetchUserInfo");
    this.$store.dispatch("updateOrders");
  },
  mounted() {}
  // async mounted() {
  //   try {
  //     this.id = await this.$store.dispatch("getUid");
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }
};
</script>

<style lang="scss">
@import "assets/scss/main";

#nav {
  //display: none;
  position: fixed;
  background: rgba(#fff, 0.8);
  right: 0;
  bottom: 0;
  text-align: center;
  padding: 15px 10px;
  box-shadow: 0 0 1rem #2c3e50;
  z-index: 1000;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
